export const getMinDate = (date: Date): Date => {
  const currentHour = date.getHours();
  const currentMinute = date.getMinutes();
  const currentTimeInMinutes = currentHour * 60 + currentMinute;
  const cutoffTimeInMinutes = 20 * 60; // 20:00 в минутах

  if (currentTimeInMinutes >= cutoffTimeInMinutes) {
    const tomorrow = new Date(date);

    tomorrow.setDate(tomorrow.getDate() + 1);

    return tomorrow;
  }

  return date;
};
